import {
    ROLES,
    ORGANIZATION_HIERARCHY
    // CONFIGURATION_KEYS
} from 'constants/enums'

export const tabs = [
    {
        id: 1,
        label: 'Detail',
        intlKey: 'tabs.detail',
        path: '/detail',
        type: 'tab'
    },
    {
        id: 2,
        label: 'Registrations',
        intlKey: 'tabs.registrations',
        path: '/registration',
        type: 'tab'
    },
    {
        id: 3,
        label: 'Payment',
        intlKey: 'tabs.payment',
        path: '/payment',
        type: 'tab'
    },
    {
        id: 4,
        label: 'Awards',
        intlKey: 'tabs.awards',
        path: '/awards',
        type: 'tab'
    },
    {
        id: 5,
        label: 'Award Units',
        intlKey: 'tabs.award_units',
        path: '/award-units',
        type: 'tab',
        displayForOrganizationTypes: [
            ORGANIZATION_HIERARCHY.RO.id,
            ORGANIZATION_HIERARCHY.OA.id,
            ORGANIZATION_HIERARCHY.NAO.id,
            ORGANIZATION_HIERARCHY.SOA.id
        ]
    },
    {
        id: 5,
        label: 'Organizations',
        intlKey: 'tabs.organizations',
        path: '/organizations',
        type: 'tab',
        displayForOrganizationTypes: [
            ORGANIZATION_HIERARCHY.GOP.id,
            ORGANIZATION_HIERARCHY.SGOP.id
        ]
    },
    {
        id: 6,
        label: 'Sub-Global Operating Partners',
        intlKey: 'tabs.sub_global_operating_partners',
        path: '/sub-global-operating-partners',
        type: 'tab',
        displayForOrganizationTypes: [ORGANIZATION_HIERARCHY.GOP.id]
    },
    {
        id: 7,
        label: 'Operating Partners',
        intlKey: 'tabs.operating_partners',
        path: '/operating-authorities',
        type: 'tab',
        displayForOrganizationTypes: [ORGANIZATION_HIERARCHY.GOP.id, ORGANIZATION_HIERARCHY.SGOP.id]
    },
    {
        id: 8,
        label: 'Sub-Operating Partners',
        intlKey: 'tabs.sub_operating_partners',
        path: '/sub-operating-authorities',
        type: 'tab',
        displayForOrganizationTypes: [ORGANIZATION_HIERARCHY.GOP.id, ORGANIZATION_HIERARCHY.SGOP.id]
    },
    {
        id: 9,
        label: 'Independent Award Centres',
        intlKey: 'tabs.independent_award_centers',
        path: '/independent-award-centres',
        type: 'tab',
        displayForOrganizationTypes: [
            ORGANIZATION_HIERARCHY.IC.id,
            ORGANIZATION_HIERARCHY.RO.id
        ]
    },
    {
        id: 10,
        label: 'Independent Countries',
        intlKey: 'tabs.independent_countries',
        path: '/independent-countries',
        type: 'tab',
        displayForOrganizationTypes: [ORGANIZATION_HIERARCHY.GOP.id]
    },
    {
        id: 11,
        label: 'Award Leaders',
        intlKey: 'tabs.award_leaders',
        path: '/award-leaders',
        type: 'tab'
    },
    {
        id: 12,
        label: 'Participants',
        intlKey: 'tabs.participants',
        path: '/participants',
        type: 'tab'
    },
    // {
    //   id: 13,
    //   label: 'Assessors',
    //   path: '/assessors',
    //   intlKey: 'tabs.assessors',
    //   roles: [ROLES.ALL.u]
    // },
    {
        id: 14,
        label: 'logs',
        intlKey: 'tabs.logs',
        path: '/logs',
        type: 'tab'
    },
    {
        id: 15,
        label: 'Customizations',
        intlKey: 'tabs.customizations',
        path: '/customizations',
        type: 'tab',
        roles: [ROLES.IF_STAFF_SUPER.u, ROLES.IF_REGION.u, ROLES.NAO_STAFF.u],
        displayForOrganizationTypes: [
            ORGANIZATION_HIERARCHY.RO.id,
            ORGANIZATION_HIERARCHY.OA.id,
            ORGANIZATION_HIERARCHY.NAO.id,
            ORGANIZATION_HIERARCHY.SOA.id,
            ORGANIZATION_HIERARCHY.GOP.id,
            ORGANIZATION_HIERARCHY.IC.id

        ]
    },
    {
        id: 16,
        label: 'Api Keys',
        intlKey: 'tabs.api_keys',
        path: '/api-keys',
        type: 'tab',
        roles: [ROLES.IF_STAFF_SUPER.u]
    }
]

export const tableHeaders = [
    {
        id: 1,
        label: 'ID',
        intlKey: 'table.id',
        sortableId: 'id'
    },
    {
        id: 3,
        label: 'Name',
        intlKey: 'table.name',
        sortableId: 'name'
    }
    // {
    //   id: 4,
    //   label: 'Registration',
    //   intlKey: 'table.registration'
    // },
    // {
    //   id: 11,
    //   label: 'Payments',
    //   intlKey: 'table.payments'
    // },
    // {
    //   id: 10,
    //   label: 'Awards',
    //   intlKey: 'table.awards'
    // },
    // {
    //   id: 5,
    //   label: 'AUs',
    //   intlKey: 'table.aus'
    // },
    // {
    //   id: 6,
    //   label: 'Leaders',
    //   intlKey: 'table.leaders'
    // },
    // {
    //   id: 7,
    //   label: 'Participants',
    //   intlKey: 'table.participants'
    // }
]
